import { UserTypes } from "../types/userType"

export const validEmail = (email: string) => {
  return /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/.test(email)
}

export const validateEmail = (email:string) => {
  return String(email)
  .toLowerCase()
  .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};


export const stepTwoValidation = (
  emails: UserTypes[],
  fn: () => void
): boolean => {
  fn()
  return true
}


export const nameValidation = (name: string): boolean => {
  
  return true
}